import { deleteRequest, getRequest, postRequest, putRequest } from "..";

export function getAll() { 
  return postRequest('/report/0/0',
    {
      currentPage: 0,
      pageSize: 99999
    }
  )
}

export function getById(id) {
  return getRequest(`/report/${id}`);
}

export function updateReport(report) {
  return putRequest('/report', report);
}

export function deleteReport(reportId) {
  return deleteRequest(`/report/${reportId}`)
}

export function getLogsById(id) {
  try {
    return getRequest(`/report/log/${id}/all`);	
  } catch {
    return Promise.resolve([]);
  }
}

export function addLog(reportId, logContent) {
  return postRequest('/report/log', { reportId, logContent });
}